import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ThemeToggle } from '../../../components/ThemeToggle';
import { useAdminSidebar } from '../AdminLayoutContext';

function AdminHeader() {
  const navigate = useNavigate();
  const { toggleSidebar } = useAdminSidebar();

  const handleLogout = () => {
    // Clear local storage or session storage
    localStorage.removeItem('token');
    localStorage.removeItem('userRole');
    localStorage.removeItem('admin');
    localStorage.removeItem('user');
    localStorage.removeItem('image');

    // Redirect to the login page
    navigate('/admin/login');
  };

  return (
  <>

    <div className="top_nav">
      <div className="nav_menu">
        <nav>
          <div className="nav toggle">
            <button
              type="button"
              id="menu_toggle"
              onClick={toggleSidebar}
              aria-label="Toggle sidebar"
              title="Toggle sidebar"
            >
              <i className="fa fa-angle-double-left admin-menu-chevron" aria-hidden />
            </button>
            <Link className="admin-profile" to="/admin/profile">
              <div className="admin-profile-img">
                <img src="img/profile-img.png" alt="Profile" />
              </div>
              <p>{localStorage.getItem('admin')}</p>
            </Link>
          </div>
          <ul className="nav navbar-nav navbar-right align-items-center">
            <li className="px-2 align-middle">
              <ThemeToggle />
            </li>
            <li>
              <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#supportModal">
                <img src="img/chat.svg" alt="Support" />
              </a>
            </li>
            <li>
              {/* Logout Button */}
              <a href="javascript:void(0);" onClick={handleLogout}>
                <img src="img/logout.svg" alt="Logout" />
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
    <div
  className="modal fade support-modal"
  id="supportModal"
  tabIndex={-1}
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
>
  <div className="modal-dialog modal-dialog-centered">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title">Support</h5>
        <button
          type="button"
          className="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        />
      </div>
      <div className="modal-body px-5 pb-0">
        <div className="row align-items-center">
          <div className="col-md-5">
            <img src="img/support-img.svg" alt="" />
          </div>
          <div className="col-md-7">
            <ul className="list-unstyled">
              <li>
                <span>
                  <i className="fa fa-phone" />
                </span>
                <a href="tel:+91 9057801818">+91 9057801818</a>
              </li>
              <li>
                <span>
                  <i className="fa fa-envelope" />
                </span>
                <a href="mailto:manishk004245@gmail.com">
                  manishk004245@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</>
  );
}

export default AdminHeader;
